import React from 'react';
interface ButtonBaseProps {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  href?: string;
  children?: React.ReactNode;
  className?: string;
}
type ButtonProps = ButtonBaseProps & Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, keyof ButtonBaseProps> & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof ButtonBaseProps>;
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-300 ease-out rounded-sm cursor-pointer no-underline';
  const variants = {
    primary: 'bg-forest-800 text-white hover:bg-forest-900 shadow-lg hover:shadow-xl hover:-translate-y-0.5',
    secondary: 'bg-stone-100 text-stone-900 hover:bg-stone-200',
    outline: 'border border-forest-800 text-forest-800 hover:bg-forest-50'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg uppercase tracking-wider font-semibold'
  };
  const allClasses = `
    ${baseStyles} 
    ${variants[variant]} 
    ${sizes[size]} 
    ${fullWidth ? 'w-full' : ''} 
    ${className}
  `;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={allClasses} {...props as React.AnchorHTMLAttributes<HTMLAnchorElement>} data-id="element-226">
        {children}
      </a>;
  }
  return <button className={allClasses} {...props as React.ButtonHTMLAttributes<HTMLButtonElement>} data-id="element-227">
      {children}
    </button>;
}